import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/input/input-enhancer.tsx
import React from "react";
var InputEnhancer = ({
  children,
  className,
  position,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cn(
      "flex items-center justify-center",
      {
        "rounded-l": position === "start",
        "rounded-r": position === "end"
      },
      className
    ),
    "data-testid": `input-${position}-enhancer`,
    ...props
  },
  children
);

export {
  InputEnhancer
};
